function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ImgS3 from "../../widgets/Menu/ImgS3";
function MenuItem() {
    var navigation = [
        {
            name: "Website",
            href: "https://www.cryptopeso.co/",
            icon: function(props) {
                return /*#__PURE__*/ _jsxs("svg", _objectSpread({}, props, {
                    stroke: "currentColor",
                    fill: "none",
                    strokeWidth: "2",
                    viewBox: "0 0 24 24",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    height: "1em",
                    width: "1em",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            d: "M19.5 7a9 9 0 0 0 -7.5 -4a8.991 8.991 0 0 0 -7.484 4"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M11.5 3a16.989 16.989 0 0 0 -1.826 4"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M12.5 3a16.989 16.989 0 0 1 1.828 4"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M19.5 17a9 9 0 0 1 -7.5 4a8.991 8.991 0 0 1 -7.484 -4"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M11.5 21a16.989 16.989 0 0 1 -1.826 -4"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M12.5 21a16.989 16.989 0 0 0 1.828 -4"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M2 10l1 4l1.5 -4l1.5 4l1 -4"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M17 10l1 4l1.5 -4l1.5 4l1 -4"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M9.5 10l1 4l1.5 -4l1.5 4l1 -4"
                        })
                    ]
                }));
            }
        },
        {
            name: "Telegram",
            href: "https://t.me/newmanperez",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({
                    stroke: "currentColor",
                    fill: "currentColor",
                    strokeWidth: 0,
                    viewBox: "0 0 448 512"
                }, props, {
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
                    })
                }));
            }
        },
        {
            name: "Twitter",
            href: "https://x.com/newmanperezcrp",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({
                    fill: "currentColor",
                    viewBox: "0 0 24 24"
                }, props, {
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z"
                    })
                }));
            }
        },
        {
            name: "Tiktok",
            href: "https://www.tiktok.com/@soynewmanperez",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({}, props, {
                    stroke: "currentColor",
                    fill: "currentColor",
                    strokeWidth: "0",
                    viewBox: "0 0 448 512",
                    height: "1em",
                    width: "1em",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                    })
                }));
            }
        },
        {
            name: "Instagram",
            href: "https://www.instagram.com/soynewmanperez/profilecard/?igsh=dzhpZDQxb2F1aHox",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({}, props, {
                    stroke: "currentColor",
                    fill: "currentColor",
                    strokeWidth: "0",
                    viewBox: "0 0 448 512",
                    height: "1em",
                    width: "1em",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                    })
                }));
            }
        },
        {
            name: "Youtube",
            href: "https://www.youtube.com/@NewmanPerez",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({}, props, {
                    stroke: "currentColor",
                    fill: "currentColor",
                    strokeWidth: "0",
                    viewBox: "0 0 576 512",
                    height: "1em",
                    width: "1em",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                    })
                }));
            }
        },
        {
            name: "Medium",
            href: "https://medium.com/@CryptoPeso",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({
                    stroke: "currentColor",
                    fill: "currentColor",
                    strokeWidth: 0,
                    viewBox: "0 0 16 16"
                }, props, {
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M9.025 8c0 2.485-2.02 4.5-4.513 4.5A4.506 4.506 0 0 1 0 8c0-2.486 2.02-4.5 4.512-4.5A4.506 4.506 0 0 1 9.025 8zm4.95 0c0 2.34-1.01 4.236-2.256 4.236-1.246 0-2.256-1.897-2.256-4.236 0-2.34 1.01-4.236 2.256-4.236 1.246 0 2.256 1.897 2.256 4.236zM16 8c0 2.096-.355 3.795-.794 3.795-.438 0-.793-1.7-.793-3.795 0-2.096.355-3.795.794-3.795.438 0 .793 1.699.793 3.795z"
                    })
                }));
            }
        },
        {
            name: "GitHub",
            href: "https://github.com/CryptoPeso",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({
                    stroke: "currentColor",
                    fill: "currentColor",
                    strokeWidth: 0,
                    viewBox: "0 0 24 24"
                }, props, {
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M12 0C5.37 0 0 5.37 0 12c0 5.3 3.438 9.8 8.205 11.385.6.113.82-.263.82-.58v-2.04c-3.338.724-4.043-1.438-4.043-1.438-.546-1.39-1.33-1.76-1.33-1.76-1.087-.744.084-.73.084-.73 1.2.085 1.832 1.23 1.832 1.23 1.07 1.835 2.805 1.305 3.49.998.107-.775.42-1.305.76-1.605-2.665-.303-5.467-1.335-5.467-5.93 0-1.31.47-2.38 1.236-3.22-.124-.302-.536-1.518.116-3.165 0 0 1.01-.324 3.3 1.23.96-.27 1.98-.404 3-.41 1.02.006 2.04.14 3 .41 2.29-1.555 3.3-1.23 3.3-1.23.653 1.647.242 2.863.12 3.165.77.84 1.236 1.91 1.236 3.22 0 4.605-2.805 5.625-5.475 5.92.432.37.81 1.102.81 2.22v3.293c0 .32.22.696.825.577C20.565 21.798 24 17.3 24 12c0-6.63-5.37-12-12-12z"
                    })
                }));
            }
        },
        {
            name: "Reddit",
            href: "https://www.reddit.com/user/CryptoPesos/?rdt=42074",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({
                    stroke: "currentColor",
                    fill: "currentColor",
                    strokeWidth: 0,
                    viewBox: "0 0 429.709 429.709"
                }, props, {
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsxs("g", {
                        children: [
                            /*#__PURE__*/ _jsx("path", {
                                d: "M429.709,196.618c0-29.803-24.16-53.962-53.963-53.962c-14.926,0-28.41,6.085-38.176,15.881 c-30.177-19.463-68.73-31.866-111.072-33.801c0.026-17.978,8.078-34.737,22.104-45.989c14.051-11.271,32.198-15.492,49.775-11.588 l2.414,0.536c-0.024,0.605-0.091,1.198-0.091,1.809c0,24.878,20.168,45.046,45.046,45.046s45.046-20.168,45.046-45.046 c0-24.879-20.168-45.046-45.046-45.046c-15.997,0-30.01,8.362-38.002,20.929l-4.317-0.959c-24.51-5.446-49.807,0.442-69.395,16.156 c-19.564,15.695-30.792,39.074-30.818,64.152c-42.332,1.934-80.878,14.331-111.052,33.785c-9.767-9.798-23.271-15.866-38.2-15.866 C24.16,142.656,0,166.815,0,196.618c0,20.765,11.75,38.755,28.946,47.776c-1.306,6.68-1.993,13.51-1.993,20.462 c0,77.538,84.126,140.395,187.901,140.395s187.901-62.857,187.901-140.395c0-6.948-0.687-13.775-1.991-20.452 C417.961,235.381,429.709,217.385,429.709,196.618z M345.746,47.743c12,0,21.762,9.762,21.762,21.762 c0,11.999-9.762,21.761-21.762,21.761s-21.762-9.762-21.762-21.761C323.984,57.505,333.747,47.743,345.746,47.743z M23.284,196.618 c0-16.916,13.762-30.678,30.678-30.678c7.245,0,13.895,2.538,19.142,6.758c-16.412,14.08-29.118,30.631-37.007,48.804 C28.349,215.937,23.284,206.868,23.284,196.618z M333.784,345.477c-31.492,23.53-73.729,36.489-118.929,36.489 s-87.437-12.959-118.929-36.489c-29.462-22.013-45.688-50.645-45.688-80.621c0-29.977,16.226-58.609,45.688-80.622 c31.492-23.53,73.729-36.489,118.929-36.489s87.437,12.959,118.929,36.489c29.462,22.013,45.688,50.645,45.688,80.622 C379.471,294.832,363.246,323.464,333.784,345.477z M393.605,221.488c-7.891-18.17-20.596-34.716-37.005-48.794 c5.247-4.22,11.901-6.754,19.147-6.754c16.916,0,30.678,13.762,30.678,30.678C406.424,206.867,401.353,215.925,393.605,221.488z"
                            }),
                            /*#__PURE__*/ _jsx("circle", {
                                fill: "currentColor",
                                cx: "146.224",
                                cy: "232.074",
                                r: "24.57"
                            }),
                            /*#__PURE__*/ _jsx("circle", {
                                fill: "currentColor",
                                cx: "283.484",
                                cy: "232.074",
                                r: "24.57"
                            }),
                            /*#__PURE__*/ _jsx("path", {
                                d: "M273.079,291.773c-17.32,15.78-39.773,24.47-63.224,24.47c-26.332,0-50.729-10.612-68.696-29.881 c-4.384-4.704-11.751-4.96-16.454-0.575c-4.703,4.384-4.96,11.752-0.575,16.454c22.095,23.695,53.341,37.285,85.726,37.285 c29.266,0,57.288-10.847,78.905-30.543c4.752-4.33,5.096-11.694,0.765-16.446C285.197,287.788,277.838,287.44,273.079,291.773z"
                            })
                        ]
                    })
                }));
            }
        },
        {
            name: "Slack",
            href: "https://cryptopesos.slack.com/team/U065B6BPGTT",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({
                    stroke: "currentColor",
                    fill: "currentColor",
                    strokeWidth: 0,
                    viewBox: "0 0 24 24"
                }, props, {
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9495 12C22.5978 11.3647 23 10.4793 23 9.5C23 7.567 21.433 6 19.5 6C18.9632 6 18.4546 6.12085 18 6.33682V4.5C18 2.567 16.433 1 14.5 1C13.5207 1 12.6353 1.40223 12 2.05051C11.3647 1.40223 10.4793 1 9.5 1C7.567 1 6 2.567 6 4.5C6 5.0368 6.12085 5.54537 6.33682 6H4.5C2.567 6 1 7.567 1 9.5C1 10.4793 1.40223 11.3647 2.05051 12C1.40223 12.6353 1 13.5207 1 14.5C1 16.433 2.567 18 4.5 18C5.0368 18 5.54537 17.8792 6 17.6632V19.5C6 21.433 7.567 23 9.5 23C10.4793 23 11.3647 22.5978 12 21.9495C12.6353 22.5978 13.5207 23 14.5 23C16.433 23 18 21.433 18 19.5C18 18.9632 17.8792 18.4546 17.6632 18H19.5C21.433 18 23 16.433 23 14.5C23 13.5207 22.5978 12.6353 21.9495 12ZM9.5 3C10.3284 3 11 3.67157 11 4.5V6H9.5C8.67157 6 8 5.32843 8 4.5C8 3.67157 8.67157 3 9.5 3ZM13 4.5C13 3.67157 13.6716 3 14.5 3C15.3284 3 16 3.67157 16 4.5V11H13V4.5ZM11 11V8H4.5C3.67157 8 3 8.67157 3 9.5C3 10.3284 3.67157 11 4.5 11H11ZM18 11H19.5C20.3284 11 21 10.3284 21 9.5C21 8.67157 20.3284 8 19.5 8C18.6716 8 18 8.67157 18 9.5V11ZM19.5 13H13V16H19.5C20.3284 16 21 15.3284 21 14.5C21 13.6716 20.3284 13 19.5 13ZM14.5 18H13V19.5C13 20.3284 13.6716 21 14.5 21C15.3284 21 16 20.3284 16 19.5C16 18.6716 15.3284 18 14.5 18ZM11 13H8V19.5C8 20.3284 8.67157 21 9.5 21C10.3284 21 11 20.3284 11 19.5V13ZM4.5 13H6V14.5C6 15.3284 5.32843 16 4.5 16C3.67157 16 3 15.3284 3 14.5C3 13.6716 3.67157 13 4.5 13Z"
                    })
                }));
            }
        },
        {
            name: "Bitcointalk",
            href: "https://bitcointalk.org/index.php?action=profile;u=3589276",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({
                    stroke: "currentColor",
                    fill: "none",
                    strokeWidth: 2,
                    viewBox: "0 0 24 24"
                }, props, {
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M10 8H14C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12M10 8V12M10 8H8.5M10 8V6.5M14 12H10M14 12C15.1046 12 16 12.8954 16 14C16 15.1046 15.1046 16 14 16H10M10 12V16M10 16H8.5M10 16V17.5M13 8V6.5M13 17.5V16M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                }));
            }
        },
        {
            name: "LinkedIn",
            href: "https://www.linkedin.com/in/crypto-peso-92a26b286/",
            icon: function(props) {
                return /*#__PURE__*/ _jsx("svg", _objectSpread({
                    stroke: "currentColor",
                    fill: "currentColor",
                    strokeWidth: 0,
                    viewBox: "0 0 16 16"
                }, props, {
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"
                    })
                }));
            }
        }, 
    ];
    return /*#__PURE__*/ _jsx("footer", {
        className: "exchange-ui border-t border-white/10 bg-zinc-950 px-4 pb-32 pt-10 sm:px-6",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto max-w-5xl",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "grid items-center gap-8 sm:grid-cols-[160px_1fr]",
                    children: [
                        /*#__PURE__*/ _jsx(ImgS3, {
                            width: "0",
                            height: "0",
                            sizes: "160px",
                            src: "/personaje.png",
                            alt: "CryptoPesos",
                            className: "mx-auto h-40 w-auto"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "mb-5 text-center text-xs font-medium uppercase tracking-widest text-zinc-400 sm:text-left",
                                    children: "CryptoPesos ecosystem"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "grid grid-cols-3 items-center justify-items-center gap-6 sm:grid-cols-5",
                                    children: [
                                        {
                                            src: "/ninja.png",
                                            name: "Ninja"
                                        },
                                        {
                                            src: "/magno.png",
                                            name: "Magno"
                                        },
                                        {
                                            src: "/sparta.png",
                                            name: "Sparta"
                                        },
                                        {
                                            src: "/blocksafu.png",
                                            name: "BlockSAFU"
                                        },
                                        {
                                            src: "/bscscan.png",
                                            name: "BSCScan"
                                        }, 
                                    ].map(function(partner) {
                                        return /*#__PURE__*/ _jsx(ImgS3, {
                                            src: partner.src,
                                            alt: partner.name,
                                            width: "0",
                                            height: "0",
                                            sizes: "100px",
                                            className: "h-auto max-h-16 w-full max-w-[100px] object-contain"
                                        }, partner.name);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "my-8 grid gap-3 sm:grid-cols-3",
                    children: [
                        {
                            name: "CryptoPesos contract",
                            href: "https://bscscan.com/address/0x86333e34c8804532ae34207c46e741cbc3ff3fe3#code"
                        },
                        {
                            name: "Project contract",
                            href: "https://bscscan.com/address/0x02319321f11f793afe658e2e20f0bd51d62832a1"
                        },
                        {
                            name: "CRP chart",
                            href: "https://poocoin.app/tokens/0x86333e34c8804532ae34207c46e741cbc3ff3fe3"
                        }, 
                    ].map(function(link) {
                        return /*#__PURE__*/ _jsxs("a", {
                            href: link.href,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "flex min-h-[52px] items-center justify-between rounded-2xl border border-white/10 bg-white/[0.03] px-4 text-sm text-zinc-300 transition-colors hover:border-orange-500/40 hover:text-white",
                            children: [
                                link.name,
                                /*#__PURE__*/ _jsx("span", {
                                    "aria-hidden": "true",
                                    className: "text-orange-400",
                                    children: "\u2197"
                                })
                            ]
                        }, link.name);
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-wrap items-center justify-center gap-2 border-t border-white/10 pt-6 sm:justify-between",
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: "/logo-yellow.png",
                            alt: "CRP Swap",
                            className: "mb-4 h-6 w-auto sm:mb-0"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex flex-wrap justify-center gap-2",
                            children: navigation.map(function(item) {
                                return /*#__PURE__*/ _jsxs("a", {
                                    href: item.href,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-zinc-400 transition-colors hover:border-orange-500/50 hover:text-orange-400",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "sr-only",
                                            children: item.name
                                        }),
                                        /*#__PURE__*/ _jsx(item.icon, {
                                            className: "h-4 w-4",
                                            "aria-hidden": "true"
                                        })
                                    ]
                                }, item.name);
                            })
                        })
                    ]
                })
            ]
        })
    });
}
export default MenuItem;
